import useButtonLoading from '../../hooks/ButtonLoading'
import { EqxLink as Link } from '@equinoxx/react'
import EqxLoading from '../EqxLoading'
import './EqxTile.css'

interface EqxTileProps {
    link?: string
    number?: number | string | React.ReactNode
    title: string
    tooltip?: string
    color?: string
    className?: string
    loading?: boolean
    icon?: string
    disabled?: boolean
    onClick?: (e: React.MouseEvent<Element, MouseEvent>) => any
    children?: React.ReactNode
    target?: string
}
const EqxTile = function (props: EqxTileProps) {
    const { onClick, loading } = useButtonLoading(props.onClick)
    let onClickHandler = undefined;
    if (props.onClick) {
        onClickHandler = (e: React.MouseEvent<Element, MouseEvent>) => {
            e.preventDefault()
            if (!props.disabled) {
                onClick(e)
            }
        }
    } else if (!props.link) {
        onClickHandler = (e: React.MouseEvent<Element, MouseEvent>) => {
            e.preventDefault()
        }
    }
    const isLoading = props.loading || loading;
    return (
        <div className={props.className}>
            <Link
                to={!props.disabled && props.link ? props.link : "#"}
                className={
                    'svg-thumbnail clickable ' +
                    (isLoading || props.disabled ? 'svg-thumbnail-disabled ' : '') +
                    (props.color ? 'bg-' + props.color : '')
                }
                title={props.tooltip}
                onClick={onClickHandler}
                target={props.target}
            >
                {isLoading ? (
                    <EqxLoading size="sm" />
                ) : props.children ? (
                    props.children
                ) : props.icon ? (
                    <div className={'tile-icon ' + props.icon}></div>
                ) : (
                    <div className="svg-thumbnail-badge data-container">{props.number}</div>
                )}
                <div className="svg-thumbnail-title">
                    <h3>{props.title} {props.target == "_blank" ? <span className="fas fa-external-link-alt"></span> : null}</h3>
                </div>
            </Link>
        </div>
    )
}
const EqxTileBlank = function (props: { className?: string }) {
    return (
        <div className={props.className}>
            <a className="svg-thumbnail svg-thumbnail-blank"></a>
        </div>
    )
}
export { EqxTile as default, EqxTileBlank }

